import { render, staticRenderFns } from "./SDCampaignView.vue?vue&type=template&id=f7d27168&scoped=true"
import script from "./SDCampaignView.vue?vue&type=script&lang=js"
export * from "./SDCampaignView.vue?vue&type=script&lang=js"
import style0 from "./SDCampaignView.vue?vue&type=style&index=0&id=f7d27168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d27168",
  null
  
)

export default component.exports